export default "assets/Pick-a-movie-vid.mp4";